import { createContext } from 'react';

export type HistoryContextType = {
  previousPath?: string;
  previousPage?: string;
  changeColorCounter: number;
  isLoaded: boolean;
};

const HistoryContext = createContext<HistoryContextType>({
  previousPath: undefined,
  previousPage: undefined,
  changeColorCounter: 0,
  isLoaded: false,
});

export default HistoryContext;
